import './feature.css';

const Feature = ({ title, text }) => {
    return (
        <div className="barmatch_features-container_feature">
            <div className="barmatch_features-container_feature-now">
                <div>

                </div>
                <h1>{title}</h1>
            </div>
            <div className="barmatch_features-container_feature-text">
                <p>{text}</p>
            </div>
        </div>
    )
}

export default Feature